import React from 'react';
import { Box, Flex, TextField } from '@radix-ui/themes';
import './linked-field-row.css';
export function LinkedFieldRow({
    fields,
    action,
}: {
    fields: React.ReactNode[];
    action: React.ReactNode;
}) {
    return (
        <Flex className="linked-field-row">
            <Flex gap="4" align="stretch" width="100%" mr="4">
                {fields}
            </Flex>

            <Box className="field-action" pt="5" >
                {action}
            </Box >
        </Flex>
    );
}
